module.exports = __webpack_public_path__ + "img/57000.a792f4fa.jpg";